var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$fetchState.pending)?_c('Loading',{attrs:{"mode":"relative"}}):_c('Values',{attrs:{"value":_vm.value,"chart-values":_vm.chartValues,"yaml-values":_vm.yamlValues,"mode":_vm.mode}})}
var staticRenderFns = []

export { render, staticRenderFns }